/**
 * First-login role bootstrap (doctor auto-assign, Approach 1).
 *
 * A doctor's first Google-login token is minted before the backend assigns
 * their role (the assignment happens when GET /me triggers identity binding).
 * So if the token carries no app scopes yet but /me reports a privileged tier,
 * the app should silently refresh the token ONCE to pick up the new scopes.
 * Capped at one retry to avoid a refresh loop when the role never materializes.
 */
export const PRIVILEGED_TIERS = ["admin", "employee", "doctor"];

export const shouldRefreshForRole = (
  hasAppAccessNow: boolean,
  tier: string | undefined | null,
  alreadyRetried: boolean,
): boolean =>
  !hasAppAccessNow &&
  !alreadyRetried &&
  !!tier &&
  PRIVILEGED_TIERS.includes(tier);
